import { useState } from 'react'
import { Switch } from '@headlessui/react'
import { classNames } from 'utils/dom-helpers'
import Translation from 'components/Translation'

export interface CouponFieldsetProps {
    class_names?: string
    label?: string
    onChange(checked: boolean): void
    value?: boolean
}

export default function FreeAppointmentToggle(p: CouponFieldsetProps) {
    const [is_free, toggleFree] = useState<boolean>(p.value as boolean)
    return (
        <div className={p.class_names || 'mt-8'}>
            <fieldset>
                <label className="flex items-center gap-3 text-sm">
                    <Switch
                        onChange={(enabled: boolean) => {
                            toggleFree(enabled)
                            p.onChange(enabled)
                        }}
                        checked={is_free}
                        className={classNames(
                            is_free
                                ? 'bg-secondary-blue'
                                : 'bg-primary bg-opacity-30',
                            'relative inline-flex flex-shrink-0 h-[24px] w-[48px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
                        )}
                    >
                        <span className="sr-only"><Translation content_key='got_coupon_disc' /></span>
                        <span
                            aria-hidden="true"
                            className={`${
                                is_free ? 'translate-x-6' : 'translate-x-0'
                            }
            pointer-events-none inline-block h-[20px] w-[20px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
                        />
                    </Switch>
                    <Translation
                        content_key={p.label || 'set_free_appointment'}
                        render_as="span"
                    />
                </label>
            </fieldset>
        </div>
    )
}
